<template>
<div class="chapter">
<div class="inner_page">
<div class="preface" id="fm">
<p class="nonindent"><em>If you’ve been sacrificing table time for grab-and-go meals, this cookbook is just the inspiration you need. <strong>At Our Table</strong> emphasizes how the experience of gathering for meals can energize us and help us reconnect with what’s really important in life. This is the fifth cookbook from this successful team, offering a combination of Shelly Reeves Smith’s engaging art and the fun and faithful recipes from author Roxie Kelley.</em></p>
<p class="extract"><em>Journey through this colorful volume’s 125 amazing recipes, from appetizers to decadent desserts, stopping along the way to savor such treats as Kelly’s Tutti Fruity Dip, Jayne’s Strawberry-Mandarin Tossed Salad, Pork Tenderloin with Ginger Glaze, and Lunch Box Brownies. If your destination of choice is back at your table, you’ll be happy you chose this book to be your guide.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781449400217_epub_fm_r1.vue?32c4eaef